// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Poppins", sans-serif !important;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0px !important;
  overflow: auto !important;
  border-radius: 8px;
  background: #f6f7fb !important;
}
html * {
  font-family: "Poppins", sans-serif !important;
}

.apexcharts-svg {
  overflow: visible !important;
}
.force-xaxis-rotate {
  transform: rotate(-45deg) !important;
  transform-origin: top right !important;
  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,6CAA6C;EAC7C,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,qBAAqB;AACvB","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif !important;\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  padding: 0px !important;\n  overflow: auto !important;\n  border-radius: 8px;\n  background: #f6f7fb !important;\n}\nhtml * {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.apexcharts-svg {\n  overflow: visible !important;\n}\n.force-xaxis-rotate {\n  transform: rotate(-45deg) !important;\n  transform-origin: top right !important;\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
